import { Button, Typography } from '@mui/material'
import { useNavigate } from '@tanstack/react-router'
import { XCircle } from 'lucide-react'
import { frenchPluralSuffix } from '~/lib/utils'
import type { PermissionTuple } from '~/utils/ability'
import { describePermission } from '~/utils/permissionLabels'
import RbacStatusPanel from './RbacStatusPanel'

export default function RbacAccessDeniedPage({
  missingPermissions,
}: {
  /** Permissions requises que l'admin courant ne possède pas (toutes affichées). */
  missingPermissions?: PermissionTuple[]
}) {
  const navigate = useNavigate()
  const described = (missingPermissions ?? []).map(describePermission)
  const plural = frenchPluralSuffix(described.length)

  return (
    <RbacStatusPanel>
      <div className="flex flex-row gap-3 items-center justify-center">
        <XCircle className="mb-4 size-12 text-destructive" />

        <Typography variant="h4" className="mb-3! font-semibold">
          Accès refusé
        </Typography>
      </div>

      <Typography className="mb-6! text-muted-foreground">
        Votre compte n'a pas la permission RBAC necessaire pour afficher cette page.
      </Typography>

      {described.length > 0 && (
        <div className="mb-6 rounded-2xl border border-sidebar-border bg-sidebar p-4 text-left">
          <Typography className="mb-3! text-sm! font-semibold">
            Permission{plural} manquante{plural} :
          </Typography>
          <ul className="flex flex-col gap-2">
            {described.map((permission) => (
              <li key={permission.key} className="text-sm">
                <span className="rounded-md bg-primary/10 px-2 py-0.5 font-medium text-primary">
                  {permission.actionLabel}
                </span>
                <span className="ml-2 text-muted-foreground">
                  {permission.segments.join(' › ')}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <Button variant="contained" onClick={() => navigate({ to: '/' })}>
        Retour a l'accueil
      </Button>
    </RbacStatusPanel>
  )
}
